import {
  DEFAULT_INVOICE_COUNTRY,
  INVOICE_DATA_FIELDS
} from "../invoiceFields";

/**
 * GUS API response shape (Polish company registry).
 * @typedef {{
 *   kod_pocztowy?: string,
 *   miejscowosc?: string,
 *   nazwa?: string,
 *   nip?: string,
 *   ulica?: string,
 *   nr_nieruchomosci?: string,
 *   nr_lokalu?: string,
 * }} GusCompanyDataResponse
 */

/**
 * Transforms GUS company data API response to partial invoice form fields.
 * Maps street, streetNumber, and flatNumber separately (no merged address).
 * Expects an array and uses the first element.
 *
 * @param {GusCompanyDataResponse[]} [response] - Raw response from app.invoices.companyData
 * @returns {Partial<Record<keyof typeof INVOICE_DATA_FIELDS, string>>} Form data slice
 */
export function gusResponseToInvoiceFormData(response) {
  if (!Array.isArray(response)) {
    return {};
  }

  const companyData = response[0];

  if (!companyData || typeof companyData !== "object") {
    return {};
  }

  const {
    kod_pocztowy,
    miejscowosc,
    nazwa,
    nip,
    ulica,
    nr_nieruchomosci,
    nr_lokalu
  } = companyData;

  const formData = {};

  if (nip) {
    formData[INVOICE_DATA_FIELDS.NIP] = nip;
  }
  if (nazwa) {
    formData[INVOICE_DATA_FIELDS.COMPANY_NAME] = nazwa;
  }
  if (ulica) {
    formData[INVOICE_DATA_FIELDS.STREET] = ulica.trim();
  }
  if (nr_nieruchomosci) {
    formData[INVOICE_DATA_FIELDS.STREET_NUMBER] = String(nr_nieruchomosci);
  }
  if (nr_lokalu) {
    formData[INVOICE_DATA_FIELDS.FLAT_NUMBER] = String(nr_lokalu);
  }
  if (miejscowosc) {
    formData[INVOICE_DATA_FIELDS.CITY] = miejscowosc;
  }
  if (kod_pocztowy) {
    formData[INVOICE_DATA_FIELDS.POSTAL_CODE] = kod_pocztowy;
  }

  if (Object.keys(formData).length > 0) {
    formData[INVOICE_DATA_FIELDS.COUNTRY] = DEFAULT_INVOICE_COUNTRY;
  }

  return formData;
}

/** @deprecated Use gusResponseToInvoiceFormData */
export function gusResponseToCompanyInvoiceFormData(response) {
  return gusResponseToInvoiceFormData(response);
}
